var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusInProgress = function SvgStatusInProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18V16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4V2Z",
    fill: "#D1D1D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 10C7 11.6569 8.34315 13 10 13V7C8.34315 7 7 8.34315 7 10Z",
    fill: "#D1D1D6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7,
    stroke: "#D1D1D6",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })));
};
export { SvgStatusInProgress as ReactComponent };
export default __webpack_public_path__ + "status-inProgress.svg";